<template>
  <div class="modal-overlay" @click.self="modalStore.closeAllModals()">
    <div class="modal-window">
      <div class="modal-content">
        <div class="modal-text-container">
          <h2 class="modal-title">Авторизация</h2>
          <button class="button-1"  @click="modalStore.openLoginModal()">Войти</button>
          <button class="button-1" @click="modalStore.openRegisterModal()">Регистрация</button>
        </div>
      </div>
      <button class="modal-close" @click="modalStore.closeAllModals()">✖</button>
    </div>
  </div>
</template>

<script>
  import { useModalStore } from "@/stores/modals";
export default {
  setup() {
    const modalStore = useModalStore();
    return { modalStore };
  }
}
</script>
<style scoped lang="scss">
@use '@/styles/mixins.scss';

</style>